
  import {Component, Vue} from 'vue-property-decorator';
  import {IApp} from "@/interfaces/app.interface";
  import {IAppTable} from "@/shared/AppTable/interfaces/sort-table-data";
  import {IAppState} from "@/interfaces/app-state.interface";
  import SimpleAppTable from "@/shared/AppTable/components/SimpleAppTable.vue";
  import ActionsCell from "@/modules/Corps/components/tableCells/ActionsCell.vue";
  import ParksCell from "@/modules/Corps/components/tableCells/ParksCell.vue";
  import CarsCell from "@/modules/Corps/components/tableCells/CarsCell.vue";
  import {ICorp} from "@/modules/Corps/interfaces/corp.interface";
  import {isMobile} from "mobile-device-detect";

  @Component({
    components: {
      ActionsCell,
      ParksCell,
      SimpleAppTable,
    }
  })
  export default class CorpsTable extends Vue {
    $refs: any;
    propType = IApp.SortingPropType;
    customComponents = {
      ActionsCell,
      ParksCell,
      CarsCell,
    };

    get storeState(): IAppState { return this.$store.state; }
    get loading() { return this.storeState.corps.loading; }
    get sortingData(): IAppTable.ISortingData { return this.storeState.corps.sortingTable; }
    get dataProps(): IAppTable.ITableProp[] {
      return [
        {
          label: 'Наименование',
          prop: 'name',
          propType: IApp.SortingPropType.String,
          actionClick: this.openEditCorp,
        },
        { label: 'E-mail',          prop: 'email',              propType: IApp.SortingPropType.String, mobileHide: true, },
        { label: 'Телефон',         prop: 'phone',              propType: IApp.SortingPropType.String, mobileHide: true, },
        { label: 'Комментарий',     prop: 'comment',            propType: IApp.SortingPropType.String, mobileHide: true, },
        {
          label: 'Родительская корпорация',
          prop: 'ownerCorpName',
          propType: IApp.SortingPropType.String,
          mobileHide: true,
        },
        {
          label: 'Парковки',
          prop: 'parks',
          propType: IApp.SortingPropType.CustomComponent,
          customComponentName: 'ParksCell',
          mobileHide: true,
          noSorting: true,
        },
        { label: 'Лимит машин',     prop: 'corpLimitResident',  propType: IApp.SortingPropType.Number, mobileHide: true, },
        {
          label: 'Кол-во машин',
          prop: 'cntCars',
          propType: IApp.SortingPropType.CustomComponent,
          customComponentName: 'CarsCell',
          mobileHide: true,
        },
        { label: 'Гостей',          prop: 'cntCarsGuest',       propType: IApp.SortingPropType.Number, mobileHide: true, },
        { label: 'Реф. код',        prop: 'refCode',            propType: IApp.SortingPropType.String, mobileHide: true, },
        { label: 'Статус',          prop: 'inArchivePrint',     propType: IApp.SortingPropType.String, noTitle: true, noSorting: true},
        {
          label: 'Действия',
          prop: 'id',
          noSorting: true,
          propType: IApp.SortingPropType.CustomComponent,
          customComponentName: 'ActionsCell',
        },
      ];
    }
    get tableList(): ICorp.IEntity[] {
      return this.$store.getters['corps/sortedList'].array.map(item => {
        return {
          ...item,
          inArchivePrint: item.enabled
            ? '<span class="color--green">Активен</span>'
            : '<span class="color--red">В архиве</span>',
        };
      });
    }

    async openEditCorp(corp: ICorp.IEntity, rowIndex: number, cell: IAppTable.ITableProp, cellIndex: number) {
      try {
        if (!isMobile) {
          this.$refs.SimpleAppTable.$refs.ActionsCell[rowIndex].openCorpPopup();
        }
      }
      catch(e) {}
    }

    setSorting(cell: IAppTable.ITableProp) {
      this.$store.commit('corps/setSorting', cell);
    }
  }
